import { ClassFormatEnum, ClassTypeEnum } from '../types/enums';

export function isEliminationPlayMatch(match: {
  tournamentGroup?: unknown;
  tournamentGroupId?: unknown;
}): boolean {
  const groupId =
    match.tournamentGroupId ??
    (match.tournamentGroup as { id?: number } | null | undefined)?.id;
  return groupId == null;
}

export function isTeamsGroupBracketCells(
  classType?: number,
  classFormat?: number,
): boolean {
  return (
    classType === ClassTypeEnum.TEAMS &&
    (classFormat === ClassFormatEnum.GROUP || classFormat === ClassFormatEnum.GROUP_ONLY)
  );
}

export function shouldRenderBracketCellSeriesInElimination(
  classType?: number,
): boolean {
  return classType === ClassTypeEnum.TEAMS;
}
